/**
 * Operator Configuration for Query Builder
 * 
 * Defines available search operators and their metadata.
 */

export type QueryOperator = 
  | 'equals'
  | 'in'
  | 'range'
  | 'match'
  | 'exists'
  | 'size'
  | 'regexp';

export interface OperatorDefinition {
  value: QueryOperator;
  label: string;
  description: string;
  requiresValue: boolean;
}

/**
 * All available query operators
 */
export const OPERATOR_DEFINITIONS: OperatorDefinition[] = [
  {
    value: 'equals',
    label: 'Equals',
    description: 'Exact match',
    requiresValue: true
  },
  {
    value: 'in',
    label: 'In',
    description: 'Match any of the values',
    requiresValue: true
  },
  {
    value: 'range',
    label: 'Range',
    description: 'Value within a range (gte, lte, gt, lt)',
    requiresValue: true
  },
  {
    value: 'match',
    label: 'Match',
    description: 'Complex object/array matching',
    requiresValue: true
  },
  {
    value: 'exists',
    label: 'Exists',
    description: 'Field exists or not',
    requiresValue: false
  },
  {
    value: 'size',
    label: 'Size',
    description: 'Array size comparison',
    requiresValue: true
  },
  {
    value: 'regexp',
    label: 'Regexp',
    description: 'Regular expression match',
    requiresValue: true
  }
];

/**
 * Get all operators
 */
export function getAllOperators(): OperatorDefinition[] {
  return OPERATOR_DEFINITIONS;
}

/**
 * Get operator definition by value
 */
export function getOperatorDefinition(operator: QueryOperator): OperatorDefinition | undefined {
  return OPERATOR_DEFINITIONS.find(op => op.value === operator);
}

/**
 * Logical group operators
 */
export type LogicalOperator = 'and' | 'or';
